export const openDocumentViewer = (url, title = 'Document') => {
  if (!url) return;

  const viewerUrl = `/document-viewer?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
  window.open(viewerUrl, '_blank', 'noopener,noreferrer');
};

export default openDocumentViewer;
